import { List, rem, ThemeIcon } from '@mantine/core';
import { IconCircleCheck, IconCircleDashed, IconCircleDashedX } from '@tabler/icons-react';
import React from 'react';

interface Rule {
  condition: boolean;
  label: string;
}

interface Props {
  rules: Rule[];
  check: boolean;
}

export const RulesConditionList = ({ rules, check }: Props) => {
  const getIndicator = (condition: boolean, isCheck: boolean) => {
    if (!isCheck) {
      return {
        icon: <IconCircleDashed style={{ width: rem(16), height: rem(16) }} />,
        color: 'blue'
      };
    }
    if (condition) {
      return {
        icon: <IconCircleCheck style={{ width: rem(16), height: rem(16) }} />,
        color: 'teal'
      };
    }
    return {
      icon: <IconCircleDashedX style={{ width: rem(16), height: rem(16) }} />,
      color: 'red'
    };
  };

  return (
    <List spacing="xs" size="sm" mb={20} center>
      {rules.map((rule, index) => (
        <List.Item
          key={index}
          icon={
            <ThemeIcon color={getIndicator(rule.condition, check).color} size={24} radius="xl">
              {getIndicator(rule.condition, check).icon}
            </ThemeIcon>
          }
        >
          {rule.label}
        </List.Item>
      ))}
    </List>
  );
};
